import React, { Component } from 'react';
import Nav from './Nav.js';
import axios from 'axios';
import {path} from './routes.js';
import PropTypes from 'prop-types';

//all pages below are the main containers for the entire app, they encompass every other container/component
import CreateThankyou from './CreateThankyou.js';
import ViewThankyous from './ViewThankyous.js';
import PrizeShop from './PrizeShop.js';
import BulkThankyou from './BulkThankyou.js';
import UserHomeScreen from './UserHomeScreen.js';
import ApproveThankyous from './ApproveThankyous.js';
import ViewOrders from './ViewOrders.js';
import BulkUser from './BulkUser.js';
import ViewUsers from './ViewUsers.js';
import AdminCenter from './AdminCenter.js';
import ASMGiftShop from './ASMGiftShop.js';
import ViewASMOrders from './ViewASMOrders.js';
import ASMRegionalCenter from './ASMRegionalCenter.js';
import ASMAdminCenter from './ASMAdminCenter.js';
import Participation from './Participation.js';
import MassEmail from './MassEmail.js';

export default class MainScreen extends Component{
	constructor(props){
		super(props);
		

		// this.state = {};
		this.state = {
			page:{
				Home:false,
				Sent:false,
				Received:false,
				Create:false,
				Shop:false,
				Orders:false,
				Pending:false,
				Add:false,
				View:false,
				Email:false,
				Mass:false,
				Prize_Requests:false,
				Admin_Center:false,
				Gift_Orders:false,
				//Gift_Shop:false,
				Order_History:false,
				Budgeting:false
			},
			messages:[],
			userCart:[],
			cartTotal:0,
			submitted:false,
			leaveShop:false
				// interval:''
		};
		this.updateCart = this.updateCart.bind(this);
		this.updateCartTotal = this.updateCartTotal.bind(this);
		this.logSubmitted = this.logSubmitted.bind(this);
		this.navigation = this.navigation.bind(this);
		this.getMessages = this.getMessages.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.leaveShop = this.leaveShop.bind(this);
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	updateCart(cart,callback=null){ //method for updating the user shopping cart. shopping cart stored in this container in order to preserve its state if user navigates to another page
		if(callback === null){
			this.setState({userCart: cart});
		}else{
			this.setState({userCart: cart},callback);
		}
	}

	updateCartTotal(item=null,action=null){ //method for updating the cart total which is also stored in this layer to preserve its value
		const total = this.state.cartTotal;
		let items = this.state.userCart;
		let newTotal;
		
		if(action === "add" && item !== null){
			newTotal = Number(item.total) + Number(total);

		}else if(action ==="remove" && item !== null){
			newTotal = Number(total) - Number(item.total);
			items.splice(items.indexOf(item),1);
		}else if(item===null && action ===null){
			newTotal = 0;
		}		
		const newCartTotal = this.props.app === 'lov'?Number(newTotal):Number(newTotal.toFixed(2));
		this.setState({cartTotal:newCartTotal, userCart:items});
	}

	//remove because the refresh will be controlled by the state
	logSubmitted(){
		if(this.state.submitted === false){
			this.setState({submitted:true});
		}else{
			this.setState({submitted:false});
		}
	}

	getMessages(){ //method that retrieves admin messages based on the app that is logged into
		const action = this.props.app === "lov" ? "admin":"asm_admin";
		axios({
			method:'post',
			url: path,
			data:{endpoint:'info',table:'messages',action:action}
		}).then((response)=>{
			let welcomeMessage = "Welcome "+this.props.userInfo.name+" to "; //default message that is always displayed
			if(this.props.app === "lov"){
				welcomeMessage += "Living Our Values!";
			}else{
				welcomeMessage += "GF Promotional Orders!";
			}
			let messages = [welcomeMessage];
			let data = response.data.data;
			data.forEach((message)=>{
				messages.push(message.message);
			});
			this.setState({messages:messages},function(){ //loop through and display admin messages
				let index = 0;
				let inter =setInterval(()=>{
					if(index === messages.length){
						index = 0;
					}
					document.getElementById("textloop").innerHTML = messages[index];
					index++;
				},7000);
				// this.setState({interval:inter});
			});
		});
	}

	componentDidMount(){ //when component mounts, display user homepage based on app and usertype
		let pages = this.state.page;
		if(this.props.app === "asm"){
			if(this.props.userInfo.userType !== "asm_admin" && this.props.userInfo.userType !== "sys_admin"){
				if(this.props.userInfo.name === "Heidi DeFazio"){
					pages['Budgeting'] = true;
				}else{
					pages['Shop'] = true;
				}
			}else{
				pages['Gift_Orders'] = true;
			}
		}else{
			pages['Home'] = true;
		}
		this.setState({page:pages},this.getMessages());
	}

	navigation(navState,navAway,navTo){ //method to handle navigation between all pages
		const newState = {};
		let updatedNavState = navState;
		updatedNavState[navAway] = false;
		updatedNavState[navTo] = true;
		newState['page'] = updatedNavState;
		this.setState(newState);
	}

	leaveShop(){
		this.navigation(this.state.page,"Shop","Gift_Orders");
		this.setState({leaveShop:true},function(){
			this.setState({leaveShop:false});
		});
	}

	render(){
		let content;
		let userType = this.props.userInfo.userType;
		if(this.props.app === "lov"){ //navigation for lov app
			if(userType !== "admin" && userType !== "sys_admin"){ //lov user and manager navigation
				content = <div>
							<div>
								<UserHomeScreen userInfo={this.props.userInfo} active={this.state.page.Home} submitted={this.state.submitted}/>
							</div>
							<div>
								<CreateThankyou userInfo={this.props.userInfo} active={this.state.page.Create} logChange={this.logSubmitted}/>
							</div>
							<div>
								<ViewThankyous userInfo={this.props.userInfo} view="Sent" active={this.state.page.Sent} submitted={this.state.submitted}/>
							</div>
							<div>
								<ViewThankyous userInfo={this.props.userInfo} view="Received" active={this.state.page.Received}/>
							</div>
							<div>
								<PrizeShop updateCart={this.updateCart} cart={this.state.userCart} cartTotal={this.state.cartTotal} updateCartTotal={this.updateCartTotal} userInfo={this.props.userInfo} redeemable={this.props.redeemable}   app={this.props.app} active={this.state.page.Shop} logChange={this.logSubmitted}  handleInput={this.handleInput}/>
							</div>
							<div>
								<ViewOrders userInfo={this.props.userInfo} app={this.props.app} redeemable={this.props.redeemable} active={this.state.page.Orders} logChange={this.logSubmitted} submitted={this.state.submitted}/>
							</div>
							<div>
								<ApproveThankyous userInfo={this.props.userInfo} active={this.state.page.Pending}/>
							</div>
						</div>;			
			}else{ //lov admin navigation
				content = <div>
							<div>
								<Participation active={this.state.page.Home}/>
							</div>
							<div>
								<ApproveThankyous userInfo={this.props.userInfo} active={this.state.page.Pending} submitted={this.state.submitted}/>
							</div>
							<div>
								<BulkUser userInfo={this.props.userInfo} active={this.state.page.Add} logChange={this.logSubmitted}/>
							</div>
							<div>
								<ViewUsers userInfo={this.props.userInfo} active={this.state.page.View} submitted={this.state.submitted}/>
							</div>
							<div>
								<MassEmail active={this.state.page.Email} type="email"/>
							</div>
							<div>
								<MassEmail active={this.state.page.Mass} type="thankyou"/>
							</div>
							<div>
								<BulkThankyou userInfo={this.props.userInfo} active={this.state.page.Create} logChange={this.logSubmitted}/>
							</div>
							<div>
								<ViewOrders userInfo={this.props.userInfo} app={this.props.app} active={this.state.page.Prize_Requests} logChange={this.logSubmitted}/>
							</div>
							<div>
								<AdminCenter userInfo={this.props.userInfo} app={this.props.app} active={this.state.page.Admin_Center}/>
							</div>
						</div>;

			}//end lov navigation
		}else{
			if(userType !== "asm_admin" && userType !=="sys_admin"){ //asm and asm_regional navigation
				content = <div>
							<div>
								<ASMGiftShop userInfo={this.props.userInfo} app={this.props.app} submitted={this.state.submitted} updateCart={this.updateCart} logChange={this.logSubmitted} cart={this.state.userCart} cartTotal={this.state.cartTotal} updateCartTotal={this.updateCartTotal} active={this.state.page.Shop} handleInput={this.handleInput} budgetUpdate={this.props.redeemable}/>
							</div>
							<div>
								<ViewASMOrders userInfo={this.props.userInfo} logChange={this.logSubmitted} submitted={this.state.submitted} app={this.props.app} view="user" active={this.state.page.Order_History} budgetUpdate={this.props.redeemable}/>
							</div>
							<div>
								<ASMRegionalCenter userInfo={this.props.userInfo} app={this.props.app} active={this.state.page.Budgeting} logChange={this.logSubmitted}/>
							</div>
						</div>;
			}else{ //asm admin navigation
				content = <div>
							<div>
								<ViewASMOrders userInfo={this.props.userInfo} app={this.props.app} logChange={this.logSubmitted} submitted={this.state.submitted} view="admin" active={this.state.page.Gift_Orders} budgetUpdate={this.props.redeemable}/>
							</div>
							<div>
								<ViewASMOrders userInfo={this.props.userInfo} app={this.props.app} view="history" active={this.state.page.Order_History}/>
							</div>
							<div>
								<ASMAdminCenter userInfo={this.props.userInfo} app={this.props.app} logChange={this.logSubmitted} submitted={this.state.submitted} active={this.state.page.Admin_Center}/>
							</div>
							<div>
								<ASMGiftShop userInfo={this.props.userInfo} app={this.props.app} submitted={this.state.submitted} updateCart={this.updateCart} logChange={this.logSubmitted} cart={this.state.userCart} cartTotal={this.state.cartTotal} updateCartTotal={this.updateCartTotal} active={this.state.page.Shop} handleInput={this.handleInput} leaveShop={this.leaveShop}/>
							</div>
						</div>;
			}
		}
		const userInfo = this.props.userInfo;
		let mainStyleClass = "fl w-100 pa4-ns pa3-m pa2 br4 br--bottom bt b--white bw1 overflow-y-auto bg-near-white";
		const mainStyle = {maxHeight:'650px',minHeight:'650px'};
		if((userInfo.userType === 'admin' || userInfo.userType === 'sys_admin') && this.state.page.Home){
				mainStyleClass = "fl w-100 pa4-ns pa3-m pa2 br4 br--bottom bt b--white overflow-x-hidden overflow-y-hidden bw1 bg-near-white";
		}
		return(
			<div>
				<div className="fl w-100 tc pb3 mt0 b--white" style={{backgroundColor:'#357edd',backgroundImage:'linear-gradient(to right,#00449E,#357edd)'}}>
					<div className="adminMessages mt0"><span className="f5 b tc lightest-blue" id="textloop">&nbsp;</span></div>
				</div>
				<div className = "fl w-100 pl0 mt0 pt0 bg-navy overflow-x-hidden">
        			<Nav onChange={this.navigation} leaveShop={this.state.leaveShop} navState={this.state.page} user={userInfo.userType} app={this.props.app} logout={this.props.logout}/>
        		</div>
       			<div className={mainStyleClass} style={mainStyle}>
					<div>{content}</div>
			 	</div>
			</div>
		);
	}
}


MainScreen.propTypes = {
	app : PropTypes.string.isRequired,
	redeemable: PropTypes.func.isRequired,
	userInfo: PropTypes.object.isRequired,
	logout: PropTypes.func.isRequired,
	handleStateUpdate: PropTypes.func.isRequired,

}


// WEBPACK FOOTER //
// ./src/container/MainScreen.js